var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:("image-popup__" + _vm.id),attrs:{"id":("image-popup__" + _vm.id),"hide-footer":"","title":"","size":"xl"}},[_c('img',{attrs:{"src":_vm.$image(_vm.image, {extension: _vm.extension}),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }